{
  "it": {
    "whats_new": {
      "category": {
        "news": "Notizia",
        "product": "Aggiornamento prodotto",
        "tip": "Consiglio"
      },
      "category_plural": {
        "news": "Notizie",
        "product": "Aggiornamenti prodotto",
        "tip": "Consigli"
      },
      "earlier": "Precedenti",
      "empty_description": "Qui compariranno nuove funzionalità, consigli e notizie da Ziggu.",
      "empty_title": "Ancora nessun post",
      "helpful": "Utile",
      "helpful_impersonation": "Non è possibile durante l'impersonificazione.",
      "helpful_mark": "Segna come utile",
      "helpful_marked": "Lo ha trovato utile",
      "image_open": "Apri immagine {index} di {count}",
      "load_failed_description": "Controlli la connessione e riprovi.",
      "load_failed_title": "Impossibile caricare i post",
      "new": "Nuovo",
      "no_matches_description": "Nessun post corrisponde alla ricerca o ai filtri. Svuoti i filtri per vedere tutto.",
      "no_matches_title": "Nessun risultato",
      "read_more": "Per saperne di più",
      "retry": "Riprova",
      "search": "Cerca post…",
      "subtitle": "Nuove funzionalità, consigli e notizie dal team Ziggu.",
      "title": "Cosa c’è di nuovo"
    }
  }
}
